[
    {
        "accountUuid": "79e17b87-9540-4a92-9f1c-5612e65261d2",
        "moduleAssignmentUuid": "7d820963-abd8-4452-9490-9ad856f69723",
        "teamUuids": [
        "0a1b2c3d-4e5f-6a7b-95c8-6e0f1a2b3c7e",
        "1b2c3d4e-5f6a-7b8c-96d9-7f1a2b3c4d8f"
        ],
        "simulationName": "Beyond Joints: The Whole-Patient Conversation",
        "percentPassed": 17,
        "avgTimeSecsToCertify": 765,
        "avgScore": 4.8,
        "usersOutOfAttempts": 0,
        "uuid": "8de66fb2-a0ec-488b-b640-1d6cf9737b20"
    },
    {
        "accountUuid": "79e17b87-9540-4a92-9f1c-5612e65261d2",
        "moduleAssignmentUuid": "7d820963-abd8-4452-9490-9ad856f69723",
        "teamUuids": [
        "0a1b2c3d-4e5f-6a7b-95c8-6e0f1a2b3c7e",
        "1b2c3d4e-5f6a-7b8c-96d9-7f1a2b3c4d8f"
        ],
        "simulationName": "The Cost Conversation: Value in a Budget-Constrained Setting",
        "percentPassed": 16,
        "avgTimeSecsToCertify": 531,
        "avgScore": 4.1,
        "usersOutOfAttempts": 0,
        "uuid": "ffa7b9bc-0af1-461f-81f0-a4fc9c24dbf1"
    },
    {
        "accountUuid": "79e17b87-9540-4a92-9f1c-5612e65261d2",
        "moduleAssignmentUuid": "e1fe4f82-11f2-48ed-83d6-f14f85db0b29",
        "teamUuids": [
        "7e8f9a0b-1c3d-4e9f-93f6-4c8f9d0e1b5c",
        "9f0a1b2c-3d4e-5f6a-94e7-5d9e0f1a2b6d"
        ],
        "simulationName": "Tailoring the Visual Aid to the Customer",
        "percentPassed": 32,
        "avgTimeSecsToCertify": 1892,
        "avgScore": 2.9,
        "usersOutOfAttempts": 3,
        "uuid": "8de66fb2-a0ec-485b-b640-1d6cf9737b20"
    },
    {
        "accountUuid": "79e17b87-9540-4a92-9f1c-5612e65261d2",
        "moduleAssignmentUuid": "e1fe4f82-11f2-48ed-83d6-f14f85db0b29",
        "teamUuids": [
        "7e8f9a0b-1c3d-4e9f-93f6-4c8f9d0e1b5c",
        "9f0a1b2c-3d4e-5f6a-94e7-5d9e0f1a2b6d"
        ],
        "simulationName": "Telling the Rukagen Story",
        "percentPassed": 71,
        "avgTimeSecsToCertify": 1091,
        "avgScore": 4.2,
        "usersOutOfAttempts": 0,
        "uuid": "ffa7b9bc-0af1-411f-81f0-a4fc9c24dbf1"
    },
    {
        "accountUuid": "79e17b87-9540-4a92-9f1c-5612e65261d2",
        "moduleAssignmentUuid": "e1fe4f82-11f2-48ed-83d6-f14f85db0b29",
        "teamUuids": [
        "7e8f9a0b-1c3d-4e9f-93f6-4c8f9d0e1b5c",
        "9f0a1b2c-3d4e-5f6a-94e7-5d9e0f1a2b6d"
        ],
        "simulationName": "Reinforcing Key Takeaways",
        "percentPassed": 74,
        "avgTimeSecsToCertify": 946,
        "avgScore": 4.8,
        "usersOutOfAttempts": 0,
        "uuid": "ffa7b9bc-0af1-411f-81f0-a4fc9c74dcf0"
    }
]